<template>
  <b-input-group>
    <b-form-input ref="input"
                  type="text"
                  v-bind="$attrs"                  
                  :size="small ? 'sm' : null"
                  class="removeMSClear"
                  :class="{ 'p-1': small }"
                  :value="value"
                  @input="onInput"
                  @change="onChange"
                  @blur.native="onBlur">
    </b-form-input>
    <b-input-group-append>
      <b-btn ref="closeButton"
             :size="small ? 'sm' : null"
             :variant="value !== undefined && value !== null ? 'primary' : 'outline-secondary'"
             :disabled="value === undefined || value === null"
             @click="clearValue"
             @blur="onBlur">
        <font-awesome-icon icon="times" />
      </b-btn>
    </b-input-group-append>
  </b-input-group>
</template>

<script>

export default {
  name: "SearchInput",

  props: {
    value: {
      type: String,
      default: null
    },
    
    small: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      fireChangeEvent: false
    }
  },

  methods: {
    // Check if input or button controle are currently focused
    hasFocus() {
      return document.activeElement === this.$refs.input.$el ||
             document.activeElement === this.$refs.closeButton;
    },

    // Fire input event
    onInput(value) {
      this.$emit('input', value);
    },

    // Fire change event only when control has focus, e.g. enter is pressed
    onChange(value) {
      this.fireChangeEvent = true;

      if (this.hasFocus())
      {
        this.emitChangeEvent(value);
      }
    },

    // Fire change event when control looses focus
    onBlur() {
      setTimeout(() => {
        if (!this.hasFocus())
          this.emitChangeEvent(this.value);
      }, 0);
    },

    // Fire change event, but only if value has changed before
    emitChangeEvent(value) {
      if (this.fireChangeEvent)
      {
        this.fireChangeEvent = false;
        this.$emit('change', value);
      }
    },

    // Clears the current value
    clearValue() {
      this.$refs.input.focus();
      this.$emit('input', null);
      this.$emit('change', null);
    }
  }
}
</script>

<style>
   /* Remove clear button on IE11 */
  .removeMSClear::-ms-clear {
      display: none;
  }
</style>
